/**
 * The small marks that used to be typed characters.
 *
 * `SheetClose.jsx` made this argument once, for the sheet header, and it holds
 * everywhere: centring a line box puts the baseline at `centre + (ascent -
 * descent) / 2` whatever the leading is, so where a glyph's ink lands after
 * that depends only on how tall that glyph happens to be. `line-height: 1`
 * moves it not at all, and a nudge tuned to one font stack is wrong in the
 * next one. Two lines in a viewBox are centred by construction.
 *
 * `SheetClose` stays its own component: it draws into a fixed 30px circle and
 * carries no type, so it has no `em` to size against. These three live in
 * controls whose box is a line of text, which is why they are sized in `em`
 * and `lh` by `.mark` in `app.css` rather than in pixels here.
 *
 * Measured at 390 x 844 against the shipped bundle, before replacing anything:
 * U+2715 advanced 9.55px inside `.icon-btn` at 13px and 11.06px inside
 * `.btn-sm` at 15px — 0.735em in both, which is why one width covers both
 * controls. U+2191 and U+2193 advanced 10px at 13px type, so the arrows get
 * their own slightly wider rule.
 */

/** The ✕. Same geometry as `SheetClose`, so the two read as one mark. */
export function CloseMark() {
  return (
    <svg className="mark" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <line
        x1="1.5"
        y1="1.5"
        x2="10.5"
        y2="10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="10.5"
        y1="1.5"
        x2="1.5"
        y2="10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

/**
 * The ↑ and ↓ on the list reorder buttons.
 *
 * One drawing rotated rather than two, because the down arrow is the up arrow
 * upside down and a second path is a second thing to keep in step. The
 * rotation is about the viewBox centre, so both occupy the same box.
 */
export function ArrowMark({ direction }) {
  return (
    <svg className="mark mark-arrow" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <g transform={direction === 'down' ? 'rotate(180 6 6)' : undefined}>
        <line
          x1="6"
          y1="10.5"
          x2="6"
          y2="2"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M2.6 5.4 6 2l3.4 3.4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
